module.exports = __webpack_public_path__ + "static/media/navlogo.3502cba9.svg";